/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Menu, MenuItem, Switch } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import React, { Dispatch, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";

import TableComponent from "../../components/TableComponent";
import { Users } from "../../types/General";
import { UPDATE_TYPES } from "../../utils/enums";
import dayjs from "dayjs";

type props = {
  rows: Users[];
  count: number;
  page?: any;
  onPageChange?: any;
  loading?: any;
  setUsers?: any;
  selectedId: string;
  setSelectedId: Dispatch<SetStateAction<string>>;
  handleDeleteUser: () => void;
  setModalType: Dispatch<SetStateAction<string>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleUserUpdate: any;
};

const ApprovedIndividualsList = ({
  rows,
  count,
  page,
  onPageChange,
  loading,
  setUsers,
  selectedId,
  setSelectedId,
  setModalType,
  setOpen,
  handleUserUpdate,
}: props) => {
  const navigate = useNavigate();

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 200,
      field: "name",
      headerName: "User Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure
              onClick={() => navigate(`/profile-detail/individual/${row?._id}`)}
            >
              <img
                src={row?.image || "/static/images/user_placeholder.png"}
                alt=""
              />
            </figure>
            <p>
              <b>{`${row?.firstName || "-"} ${row?.lastName || ""}`}</b>
              {row?.countryCode} {row?.phone || "-"} <br />
              {row?.email || "-"}
            </p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 300,
      field: "address",
      headerName: "Address",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.addressObject?.address || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 300,
      field: "createdAt",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {row?.createdAt
                ? dayjs(row?.createdAt).format("DD-MM-YYYY")
                : "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 150,
      field: "status",
      filterable: false,
      sortable: false,
      headerName: "Block/Unblock",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={!row?.isBlocked}
            onChange={() =>
              handleUserUpdate(row?._id, !row?.isBlocked, UPDATE_TYPES.BLOCK)
            }
          />
        );
      },
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="table_actions v2">
          <Box>
            <IconButton
              onClick={() => navigate(`/profile-detail/individual/${row?._id}`)}
            >
              <img src="/static/images/eye_icon.svg" alt="" />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              onClick={() =>
                navigate(`/edit-profile-detail/individual/${row?._id}`)
              }
            >
              <img src="/static/images/edit2_icon.svg" alt="" />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              onClick={() => {
                setModalType("delete");
                setSelectedId(row?._id);
                setOpen(true);
              }}
            >
              <img src="/static/images/trash2_icon.svg" alt="" />
            </IconButton>
          </Box>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={onPageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default ApprovedIndividualsList;
